import { PersonImage } from './PersonImage';

export const SubstituteImage = ({ substitute }) => {
  if (!substitute) {
    return null;
  }

  return <PersonImage person={{ ...substitute }} sm />;
};
